import {
    KNOWLEDGE_DATA_LIST_REQUEST,
    KNOWLEDGE_DATA_LIST_RESPONSE,
    KNOWLEDGE_DATA_LIST_CACHED_RESPONSE,
    KNOWLEDGE_DATA_LIST_ERROR_RESPONSE
} from "../actions/action-types"
import {
    knowledgeDataListCachedResponse,
    knowledgeDataListResponse,
    knowledgeDataListErrorResponse
} from "../actions/knowledge-data-actions"
import { getKnowledgeDataList } from "../api/knowledge-data-api"
import {
    requestListEpic,
    callbackActionCreatorEpic
} from "./default-epics/default-entity-epics"

export const requestKnowledgeListEpic = requestListEpic(
    KNOWLEDGE_DATA_LIST_REQUEST,
    getKnowledgeDataList,
    "knowledgeData",
    knowledgeDataListResponse,
    knowledgeDataListCachedResponse,
    knowledgeDataListErrorResponse
)

export const responseKnowledgeCallbackEpic = callbackActionCreatorEpic(
    KNOWLEDGE_DATA_LIST_RESPONSE,
    KNOWLEDGE_DATA_LIST_CACHED_RESPONSE,
    KNOWLEDGE_DATA_LIST_ERROR_RESPONSE
)
